/* eslint-disable */
// FrameDetailModal — Originals Frame Detail panel (Gallery Spotlight), New DNA.
// Replaces the legacy ItemDetailModal (split out of CatalogModals.js, which was
// over the 300-LOC cap). Read-only over the already-loaded grid item; composes
// FrameDetailStage (left) + FrameDetailPanel (right). Backdrop uses the
// mousedown-origin guard from the Create-Modals arc (no drag-out false close);
// no dirty guard (read-only). Same prop/handler contract as the old modal.
import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import FrameDetailStage from "./FrameDetailStage";
import FrameDetailPanel from "./FrameDetailPanel";
import styles from "./FrameDetailModal.module.css";

export function FrameDetailModal({
  selected, setSelected, setEditing, setLightboxSrc, setFullScreen, setFsImgIdx, setFsZoomed, setDevRequestItem,
  detailImgIdx, setDetailImgIdx, fields, perm, role, comments, commentsLoading, commentText, setCommentText,
  addComment, handleDelete, userNameMap, isMobile, T, linkedDevs = [], setTab,
}) {
  const backdropRef = useRef(null);
  const downOnBackdrop = useRef(false);

  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") setSelected(null); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [setSelected]);

  const imgs = (selected.images || []).length > 0 ? selected.images : (selected.image ? [selected.image] : []);
  const activeImg = imgs[detailImgIdx] || imgs[0];

  return createPortal(
    <div className={styles.fdRoot}>
      <div
        ref={backdropRef}
        className={styles.backdrop}
        onMouseDown={(e) => { downOnBackdrop.current = (e.target === backdropRef.current); }}
        onMouseUp={(e) => {
          if (downOnBackdrop.current && e.target === backdropRef.current) setSelected(null);
          downOnBackdrop.current = false;
        }}
      >
        <div className={styles.card} role="dialog" aria-modal="true" aria-label={`${selected.brand || "Frame"} detail`} data-test="frame-detail-modal">
          <FrameDetailStage
            selected={selected} imgs={imgs} activeImg={activeImg}
            detailImgIdx={detailImgIdx} setDetailImgIdx={setDetailImgIdx}
            devCount={linkedDevs.length}
            onZoom={() => { if (activeImg) setLightboxSrc(activeImg); }}
          />
          <FrameDetailPanel
            selected={selected} setSelected={setSelected} setEditing={setEditing}
            setFullScreen={setFullScreen} setFsImgIdx={setFsImgIdx} setFsZoomed={setFsZoomed}
            setDevRequestItem={setDevRequestItem} fields={fields} perm={perm} role={role}
            comments={comments} commentsLoading={commentsLoading} commentText={commentText}
            setCommentText={setCommentText} addComment={addComment} handleDelete={handleDelete}
            userNameMap={userNameMap} linkedDevs={linkedDevs} setTab={setTab}
          />
        </div>
      </div>
    </div>,
    document.body
  );
}
